<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">创建模板</div>
    <div class="third-title"><span>基础规则</span></div>
    <div class="order-detail-basic">
      <el-form :model="fullReduction" label-width="150px" :rules="rules" ref="formRef">
        <el-form-item label="活动类型:" prop="activeType">
          <div style="display:flex;">
            <div v-for="(item, index) in activeTypeList" :key="index" :class="fullReduction.activityType === item.type ? 'select activeType' : 'activeType'"
              @click="activityStatus ? '' : activeTypeChange(item)">
              <p>{{ item.name }}</p>
              <div>{{ item.content }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="活动名称:" prop="activityName">
          <el-input v-model="fullReduction.activityName" placeholder="" style="width:420px !important;" type="text" maxlength="25" show-word-limit :disabled="activityStatus">
          </el-input>
          <p style="color:#aaa;">该名称仅用于管理，不对买家展示 </p>
        </el-form-item>
        <el-form-item label="活动时间:" prop="activeTime">
          <el-date-picker v-model="activeTime" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" align="left" unlink-panels range-separator="到"
            start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions" :disabled="activityStatus">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="满减类型:">
          <el-radio-group v-model="fullReduction.activityScope" @input="activityScopeChange" :disabled="activityStatus">
            <el-radio label="1">各自满减</el-radio>
            <el-radio label="2">混合满减</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠设置:">
          <div>{{ fullReduction.activityType === 'FULL_AMOUNT' ? '阶梯满减' : '阶梯优惠' }}</div>
          <div class="ladder">
            <div v-show="fullReduction.activityType === 'FULL_NUMBER'">
              <el-radio-group v-model="fullReduction.ladderDiscounts" @input="ladderDiscountsChange" :disabled="activityStatus">
                <el-radio label="2">满N件 打X折</el-radio>
                <el-radio label="3">满N件 减X元</el-radio>
                <el-radio label="4">满N件 每件减X元</el-radio>
              </el-radio-group>
            </div>
            <!-- <div>
              <div class="ladderItem" v-for="(item, index) in ruleList" :key="'ladder' + index">满 <el-input-number v-if="fullReduction.ladderDiscounts != 1" v-model.number="item.fullAmount"
                  placeholder="请输入" controls-position="right" :min="1" :max="999" style="width:120px;margin: 0 10px;" :controls="false" :disabled="activityStatus">
                </el-input-number>
                <el-input-number v-else v-model="item.fullAmount" placeholder="请输入" controls-position="right" :min="1" :max="99999" style="width:120px;margin: 0 10px;" :precision="2" :controls="false"
                  @change="ruleCheck" :disabled="activityStatus"></el-input-number>{{ fullReduction.ladderDiscounts == 1 ? '元' : '件' }} {{ fullReduction.ladderDiscounts == 2 ? '打' :
                      '减'
                  }} <el-input-number v-model="item.discountAmount" placeholder="请输入" controls-position="right" :min="0.1" :max="fullReduction.ladderDiscounts == 2 ? 10 : 999"
                  style="width:120px;margin: 0 10px;" :precision="fullReduction.ladderDiscounts == 2 ? 1 : 2" :controls="false" @change="ruleCheck" :disabled="activityStatus">
                </el-input-number>{{ fullReduction.ladderDiscounts == 2 ? '折' : '元' }}<i class="el-icon-delete" @click="activityStatus ? '' : deleteRule(index)"
                  :style="ruleList.length > 1 ? 'color: #409EFF;margin-left:10px;' : 'margin-left:10px;'"></i>
              </div>
            </div> -->
            <div v-if="fullReduction.ladderDiscounts == 1">
              <div class="ladderItem" v-for="(item, index) in ruleList" :key="'ladder' + index">满 <el-input-number v-model="item.fullAmount" placeholder="请输入" controls-position="right" :min="1"
                  :max="99999" style="width:120px;margin: 0 10px;" :controls="false" :precision="2" @change="ruleCheck" :disabled="activityStatus"></el-input-number>元 减<el-input-number
                  v-model="item.discountAmount" placeholder="请输入" controls-position="right" :min="1" :max="99999" style="width:120px;margin: 0 10px;" :precision="2" :controls="false"
                  @change="ruleCheck" :disabled="activityStatus"></el-input-number>元<i class="el-icon-delete" @click="activityStatus ? '' : deleteRule(index)"
                  :style="ruleList.length > 1 ? 'color: #409EFF;margin-left:10px;' : 'margin-left:10px;'"></i></div>
            </div>
            <div v-if="fullReduction.ladderDiscounts == 2">
              <div class="ladderItem" v-for="(item, index) in ruleList" :key="'ladder' + index">满 <el-input-number v-model.number="item.fullAmount" :precision="0" placeholder="请输入"
                  controls-position="right" :min="1" :max="999" style="width:120px;margin: 0 10px;" :controls="false" @change="ruleCheck" :disabled="activityStatus"></el-input-number>件 打
                <el-input-number v-model="item.discountAmount" placeholder="请输入" controls-position="right" :min="0.1" :max="9.9" style="width:120px;margin: 0 10px;" :precision="1" :controls="false"
                  @change="ruleCheck" :disabled="activityStatus">
                </el-input-number>折 <i class="el-icon-delete" @click="activityStatus ? '' : deleteRule(index)"
                  :style="ruleList.length > 1 ? 'color: #409EFF;margin-left:10px;' : 'margin-left:10px;'"></i></div>
            </div>
            <div v-if="fullReduction.ladderDiscounts == 3">
              <div class="ladderItem" v-for="(item, index) in ruleList" :key="'ladder' + index">满 <el-input-number v-model.number="item.fullAmount" placeholder="请输入" controls-position="right" :min="1"
                  :max="999" style="width:120px;margin: 0 10px;" :controls="false" @change="ruleCheck" :disabled="activityStatus" :precision="0"></el-input-number>件 减 <el-input-number
                  v-model="item.discountAmount" placeholder="请输入" controls-position="right" :min="1" :max="99999" style="width:120px;margin: 0 10px;" :precision="2" :controls="false"
                  @change="ruleCheck" :disabled="activityStatus">
                </el-input-number>元 <i class="el-icon-delete" @click="activityStatus ? '' : deleteRule(index)"
                  :style="ruleList.length > 1 ? 'color: #409EFF;margin-left:10px;' : 'margin-left:10px;'"></i></div>
            </div>
            <div v-if="fullReduction.ladderDiscounts == 4">
              <div class="ladderItem" v-for="(item, index) in ruleList" :key="'ladder' + index">满 <el-input-number v-model.number="item.fullAmount" placeholder="请输入" controls-position="right" :min="1"
                  :max="999" style="width:120px;margin: 0 10px;" :controls="false" @change="ruleCheck" :disabled="activityStatus" :precision="0"></el-input-number>件 每件减 <el-input-number
                  v-model="item.discountAmount" placeholder="请输入" controls-position="right" :min="1" :max="99999" style="width:120px;margin: 0 10px;" :precision="2" :controls="false"
                  @change="ruleCheck" :disabled="activityStatus">
                </el-input-number>元 <i class="el-icon-delete" @click="activityStatus ? '' : deleteRule(index)"
                  :style="ruleList.length > 1 ? 'color: #409EFF;margin-left:10px;' : 'margin-left:10px;'"></i></div>
            </div>
            <div class="addRule" @click="activityStatus ? '' : addRule(5)" v-if="fullReduction.ladderDiscounts == 1">新增规则（{{ ruleList.length }}/5）</div>
            <div class="addRule" @click="activityStatus ? '' : addRule(3)" v-else>新增规则（{{ ruleList.length }}/3）</div>
            <div v-show="fullShow" style="color:red;">【满{{ fullReduction.ladderDiscounts == 1 ? '额' : '件' }}】不能为空</div>
            <div v-show="deductionShow" style="color:red;">{{ fullReduction.ladderDiscounts == 2 ? '【打折】' : '【减额】' }}不能为空</div>
            <div v-show="filledMinShow" style="color:red;">下一层级的【满{{ fullReduction.ladderDiscounts == 1 ? '额' : '件' }}】需要大于上一层级的【满{{ fullReduction.ladderDiscounts == 1 ? '额' : '件' }}】</div>
            <div v-show="reduceMinShow" style="color:red;">下一层级的【优惠力度】需要大于上一层级的【优惠力度】</div>
            <div v-show="amountShow" style="color:red;">【减额】需要小于【满额】</div>
          </div>
        </el-form-item>
        <el-form-item label="选择产品:">
          <div style="display: flex;flex-wrap:wrap;align-items: center;">
            <!-- <div v-for="item in choiceProdListNew" :key="item.id">{{ item.name }}</div> -->
            <span class='tag' v-for="item in choiceProdListNew" :key="item.id" style="font-size:13px">{{ item.spuName }}</span>
          </div>
          <div class="addProd" @click="addProduct">添加产品</div>
        </el-form-item>
        <el-form-item label="要求收货地址相同">
          <el-radio v-model="fullReduction.isSameAddress" :label="1" :disabled="activityStatus">是</el-radio>
          <el-radio v-model="fullReduction.isSameAddress" :label="0" :disabled="activityStatus">否</el-radio>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="submit()" v-preventReClick>提交</el-button>
      <el-button round @click="cancel()" v-preventReClick>取消</el-button>
    </div>
    <el-drawer :visible.sync="drawer" :with-header="true" size="50%" title="添加产品" :wrapperClosable="false">
      <div class="drawerContent">
        <span>产品名称：</span>
        <el-input placeholder="请输入产品名称" v-model="spuName" class="input-with-select" style="width:300px !important;">
          <el-button slot="append" icon="el-icon-search" style="width:50px;" @click="searchProd"></el-button>
        </el-input>
        <div style="margin-top:20px;display: flex;flex-wrap:wrap;align-items: center;">已选产品：<div class='tag' v-for="(item, index) in choiceProdList" :key="item.id" style="font-size:13px">{{
          item.spuName }}<i @click="deleteProd(index)" class="el-icon-close"></i></div>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top:20px;overflow: auto;" align="left" height="calc(100vh - 220px)">
          <el-table-column prop="spuName" label="产品信息" width="280">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;">
                <img :src="scope.row.spuImage" alt="" width="50" height="50">
                <div style="padding-left: 10px;">{{ scope.row.spuName }}</div>
              </div>
              <div style="color:red;font-size:12px" v-show="scope.row.discountActivityList.length > 0">已参加其他活动</div>
            </template>
          </el-table-column>
          <el-table-column prop="spuMinBasePrice" label="产品会员价" width="100">
            <template slot-scope="scope"> {{ scope.row.spuMinBasePrice === scope.row.spuMaxBasePrice ? `￥${scope.row.spuMinBasePrice}` : `￥${scope.row.spuMinBasePrice}-￥${scope.row.spuMaxBasePrice}`
            }} </template>
          </el-table-column>
          <el-table-column prop="address" label="产品库存">
            <template> 9999 </template>
          </el-table-column>
          <el-table-column prop="address" label="同时段活动参与情况">
            <template slot-scope="scope">
              <div v-if="scope.row.discountActivityList.length > 0">
                <div v-for="item in scope.row.discountActivityList" :key="item.id"> {{ item.activityName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <span @click="choiceProd(scope.row)" class="color-blue" v-if="scope.row.discountActivityList.length < 1">选择</span>
              <span v-else style="color:#aaa;">选择</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="form-btn" style="position: fixed;bottom: 20px;right: 0;">
          <el-button round type="primary" @click="confirm()" v-preventReClick>确定</el-button>
          <el-button round @click="drawer = false" v-preventReClick>取消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 取消确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="cancelDialog" width="30%">
      <span>取消后，已编辑的内容将不被保存，是否确认取消?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog = false">取 消</el-button>
        <el-button type="primary" @click="cancelOn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getSpuListForActivity, activityAdd, activityEdit, getActivityById } from '@/api/pms'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { storeTypeGetStoreTypeList } from '@/api/crm'
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      cancelDialog: false,
      fullShow: false,
      deductionShow: false,
      filledMinShow: false,
      reduceMinShow: false,
      amountShow: false,
      choiceProdList: [],
      choiceProdListNew: [], // 外面的选择产品列表
      tableData: [],
      drawer: false,
      ruleList: [{ discountAmount: undefined, fullAmount: undefined }],
      activeTypeList: [{ type: 'FULL_AMOUNT', name: '满N元优惠', content: '同一产品或跨产品购买金额满足门槛，可享受总价立减，可用于提升客单价' },
      { type: 'FULL_NUMBER', name: '满N件优惠', content: '同一商品或跨商品购买件数满足门槛，可享受总价/单价立减或折扣，可用于提升销量' }],
      activityStatus: false,
      fullReduction: {
        activityType: 'FULL_AMOUNT',
        activityName: '',
        activityScope: '1',
        ladderDiscounts: '1',
        isSameAddress: 1
      },
      newForm: '',
      selectIndex: 0,
      activeTime: [
        this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        this.$moment().subtract(-3, 'month').format('YYYY-MM-DD HH:mm:ss')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24 * 1
        }
      },
      // 分割
      addGroupVo: {
        skuList: [],
        composeSizeGroup: {},
        composeSizeGroupId: '',
        groupBelong: 0,
        groupName: '',
        isAssociatedeSizeGroup: '',
        storeList: []
      },
      spuName: '',
      rules: {
        activityName: [
          {
            required: true,
            message: '请填写活动名称',
            trigger: 'blur'
          }
        ]
      },
      id: null,
      type: ''
    }
  },
  async created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    let nowDate = new Date()
    this.fullReduction.activityName = '满减 ' + this.$moment(nowDate).format('YYYYMMDD HH:mm:ss')
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    if (this.id) {
      await getActivityById(this.id).then(res => {
        let detail = res.data.data
        if (detail) {
          if (detail.activityStatus === 'PROGRESSING' && this.type == 'edit') {
            this.activityStatus = true
          }
          this.fullReduction = {
            activityType: detail.activityType,
            activityName: detail.activityName,
            activityScope: detail.activityScope,
            ladderDiscounts: detail.ladderDiscounts,
            isSameAddress: detail.isSameAddress,
            activityStatus: detail.activityStatus
          }
          this.ruleList = detail.rules
          this.activeTime = [detail.dateStart, detail.dateEnd]
          this.choiceProdListNew = detail.spuXrefs.map(a => {
            return {
              ...a,
              id: a.spuId
            }
          })
        }
      })
    }
    let newForm = {
      ...this.fullReduction,
      ruleList: this.ruleList,
      activeTime: this.activeTime,
      choiceProdListNew: this.choiceProdListNew
    }
    this.newForm = JSON.stringify(newForm)
  },
  methods: {
    replacement () {
      this.ruleList = [{ discountAmount: undefined, fullAmount: undefined }]
      this.fullShow = false // 满额判断
      this.deductionShow = false // 减额判断
      this.filledMinShow = false // 满额层级判断
      this.reduceMinShow = false // 减额层级判断
      this.amountShow = false // 满额等于减额
    },
    activeTypeChange (item) {
      this.replacement()
      this.ruleCheck()
      this.fullReduction.activityType = item.type
      if (item.type == 'FULL_AMOUNT') {
        this.fullReduction.ladderDiscounts = '1'
        this.ruleList = [{ discountAmount: undefined, fullAmount: undefined }]
      } else {
        this.fullReduction.ladderDiscounts = '2'
        this.ruleList = [{ discountAmount: undefined, fullAmount: undefined }]
      }
    },
    addProduct () {
      this.choiceProdList = JSON.parse(JSON.stringify(this.choiceProdListNew))
      this.drawer = true
    },
    searchProd () {
      getSpuListForActivity({
        spuName: this.spuName,
        dateEnd: this.activeTime[1],
        dateStart: this.activeTime[0]
      }).then(res => {
        console.log('res', res)
        if (res.data.data) {
          this.tableData = res.data.data
        }
      })
    },
    activityScopeChange (val) {
      this.replacement()
      this.ruleCheck()
      console.log('activityScopeChange', val)
    },
    ladderDiscountsChange (val) {
      this.replacement()
      this.ruleCheck()
    },
    // 校验最大值
    numberChange (val, maxNum) {
      // 转换数字类型
      this.queryParams.startScore = Number(val)
      // 重新渲染
      this.$nextTick(() => {
        // 比较输入的值和最大值，返回小的
        let num = Math.min(Number(val), maxNum)
        // 输入负值的情况下， = 0（可根据实际需求更该）
        if (num < 0) {
          this.queryParams.startScore = 0
        } else {
          // 反之
          this.queryParams.startScore = num
        }
      })
    },
    // addRule () {
    //   if (this.ruleList.length < 5) {
    //     this.ruleList.push({ fullAmount: '', discountAmount: '' })
    //   }
    // },
    // deleteLadder (index) {
    //   if (this.ruleList.length > 1) {
    //     this.ruleList.splice(index, 1)
    //   }
    // },
    addRule () {
      if (this.fullReduction.activityType === 'FULL_AMOUNT') {
        if (this.ruleList.length < 5) {
          this.ruleList.push({ discountAmount: undefined, fullAmount: undefined })
        }
      } else {
        if (this.ruleList.length < 3) {
          this.ruleList.push({ discountAmount: undefined, fullAmount: undefined })
        }
      }
    },
    deleteRule (index) {
      if (this.ruleList.length > 1) {
        this.ruleList.splice(index, 1)
      }
      this.ruleCheck()
    },
    // 删除选择的产品
    deleteProd (index) {
      // this.ComposeSizeGroupVo.composeSizeIdSet.splice(index, 1)
      this.choiceProdList.splice(index, 1)
    },
    choiceProd (row) {
      if ((this.fullReduction.activityType == 'FULL_AMOUNT' || this.fullReduction.ladderDiscounts == 3) && row.discountBundle) {
        this.$message.error('产品已开启折扣包优惠，不得再次参与该满减活动。')
        return
      }
      let lock = true
      this.choiceProdList.forEach(item => {
        if (item.id == row.id) {
          this.$message.error('已选择')
          lock = false
        }
      })
      if (lock) {
        // 添加id
        // this.ComposeSizeGroupVo.composeSizeIdSet.push(row.id)
        // 添加到页面
        this.choiceProdList.push(row)
      }
    },
    confirm () {
      this.choiceProdListNew = this.choiceProdList.map(res => {
        return {
          spuName: res.spuName,
          id: res.id
        }
      })
      this.drawer = false
    },
    // 判断
    ruleCheck () {
      this.fullShow = false // 满额判断
      this.deductionShow = false // 减额判断
      this.filledMinShow = false // 满额层级判断
      this.reduceMinShow = false // 减额层级判断
      this.amountShow = false // 满额等于减额
      for (let k in this.ruleList) {
        if (!this.ruleList[k].fullAmount) {
          this.fullShow = true
          return true
        }
        if (!this.ruleList[k].discountAmount) {
          this.deductionShow = true
          return true
        }
        console.log('this.ruleList[k].fullAmount', this.ruleList[k].fullAmount)
        if (k > 0 && (this.ruleList[k].fullAmount < this.ruleList[k - 1].fullAmount || this.ruleList[k].fullAmount == this.ruleList[k - 1].fullAmount)) {
          this.filledMinShow = true
          return true
        }
        if (this.fullReduction.ladderDiscounts == 2) {
          if (k > 0 && (this.ruleList[k].discountAmount > this.ruleList[k - 1].discountAmount || this.ruleList[k].discountAmount == this.ruleList[k - 1].discountAmount)) {
            this.reduceMinShow = true
            return true
          }
        } else {
          if (k > 0 && (this.ruleList[k].discountAmount < this.ruleList[k - 1].discountAmount || this.ruleList[k].discountAmount == this.ruleList[k - 1].discountAmount)) {
            this.reduceMinShow = true
            return true
          }
        }
        if ((this.ruleList[k].fullAmount == this.ruleList[k].discountAmount || this.ruleList[k].discountAmount > this.ruleList[k].fullAmount) && this.fullReduction.ladderDiscounts == 1) {
          this.amountShow = true
          return true
        }
      }
    },
    // 提交
    submit () {
      let value = this.ruleCheck()
      if (value) {
        return true
      }
      if (this.activeTime[1] === this.activeTime[0]) {
        this.$message.error('活动开始时间不能等于结束时间')
        return
      }
      // 创建目标时间的Date对象
      let targetTimeStart = new Date(this.$moment(this.activeTime[0]).format('YYYY-MM-DD'))
      let targetTimeEnd = new Date(this.$moment(this.activeTime[1]).format('YYYY-MM-DD'))
      let currentTime = new Date(this.$moment().format('YYYY-MM-DD'))
      // 获取目标时间和当前时间的时间戳
      let targetTimestampStart = targetTimeStart.getTime()
      let targetTimestampEnd = targetTimeEnd.getTime()
      let currentTimestamp = currentTime.getTime()

      if (this.choiceProdListNew.length < 1) {
        this.$message.error('请选择产品')
        return
      }
      if (this.choiceProdListNew.length > 100) {
        this.$message.error('最多添加100个产品')
        return
      }
      let isHaveDiscount = this.choiceProdListNew.find(a => a.discountBundle)
      if ((this.fullReduction.activityType == 'FULL_AMOUNT' || this.fullReduction.ladderDiscounts == 3) && isHaveDiscount) {
        this.$message.error('产品已开启折扣包优惠，不得再次参与该满减活动。')
        return
      }
      let ruleList = this.ruleList.map((res, index) => {
        return {
          ...res,
          sorting: index
        }
      })
      let params = {
        ruleList: ruleList,
        ...this.fullReduction,
        activityName: this.fullReduction.activityName.trim(),
        spuIdList: this.choiceProdListNew.map(res => { return res.id }),
        dateEnd: this.activeTime[1],
        dateStart: this.activeTime[0],
        id: this.id && this.type == 'edit' ? this.id : null
      }
      if (this.id && this.type == 'edit') {
        // 活动进行中的时候编辑不判断时间
        console.log('his.fullReduction.activityStatus', this.fullReduction.activityStatus)
        if (this.fullReduction.activityStatus !== 'PROGRESSING') {
          if (targetTimestampStart < currentTimestamp) {
            this.$message.error('活动开始日期不能早于当前日期')
            return
          }
          if (targetTimestampEnd < currentTimestamp) {
            this.$message.error('活动结束日期不能早于当前日期')
            return
          }
        }
        activityEdit(params).then(a => {
          if (a.data.success) {
            this.$message.success('编辑成功')
            this.$router.push('./manageFullReduction')
          }
        })
      } else {
        if (targetTimestampStart < currentTimestamp) {
          this.$message.error('活动开始日期不能早于当前日期')
          return
        }
        if (targetTimestampEnd < currentTimestamp) {
          this.$message.error('活动结束日期不能早于当前日期')
          return
        }
        activityAdd(params).then(a => {
          if (a.data.success) {
            this.$message.success('创建成功')
            this.$router.push('./manageFullReduction')
          }
        })
      }
    },
    // 取消
    cancel () {
      console.log('this.fullReduction', this.fullReduction, '---', this.fullReduction)
      console.log('this.ruleListNew', this.ruleListNew, '---', this.ruleList)
      let newForm = {
        ...this.fullReduction,
        ruleList: this.ruleList,
        activeTime: this.activeTime,
        choiceProdListNew: this.choiceProdListNew
      }
      if (JSON.stringify(newForm) != this.newForm) {
        this.cancelDialog = true
      } else {
        if (this.id) {
          this.$router.push('./manageFullReduction')
        }
      }
    },
    // 确认取消
    cancelOn () {
      this.cancelDialog = false
      if (this.id) {
        this.$router.push('./manageFullReduction')
      } else {
        this.fullReduction = JSON.parse(this.fullReduction)
        this.ruleList = JSON.parse(this.ruleListNew)
      }
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  /deep/ .el-input {
    width: 100% !important;
  }

  .el-input-number {
    line-height: 30px !important;
  }

  /deep/ .el-input-number__increase {
    line-height: 15px !important;
  }

  .el-input-number__decrease {
    line-height: 15px !important;
  }

  // .spec-mm {
  //   span {
  //     margin-right: 10px;
  //   }

  //   .el-input {
  //     width: 110px;
  //   }

  //   @{deep} .el-input-group__append {
  //     padding: 0 15px;
  //   }
  // }

  // .link {
  //   width: 30px;
  //   height: 30px;
  //   border: 1px solid #dcdfe6;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   border-radius: 4px;
  //   box-sizing: border-box;

  //   i {
  //     font-size: 20px;
  //     color: #999;
  //   }
  // }

  // .active-link {
  //   background: #1473e6;
  //   border: 1px solid #1473e6;

  //   i {
  //     color: #fff;
  //   }
  // }
}

.activeType {
  margin-right: 20px;
  border: 1px solid #DCDFE6;
  padding: 15px;
  border-radius: 5px;
  width: 300px;

  p {
    font-size: 18px;
    padding-bottom: 5px;
    font-weight: 500;
    color: #000;
  }
}

.select {
  position: relative;
  border: 1px solid #409EFF !important;
  box-shadow: 0px 1px 3px 0px rgba(85, 110, 97, 0.35);

  ::before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    border-top-right-radius: 5px;
    border: 15px solid #1473e6;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }

  ::after {
    content: '';
    width: 4px;
    height: 8px;
    position: absolute;
    right: 6px;
    top: 2px;
    border: 1px solid #fff;
    border-top-color: transparent;
    border-left-color: transparent;
    transform: rotate(35deg);
  }
}

.ladder {
  padding: 10px 20px;
  background: rgb(250, 250, 250);

  .ladderItem {
    margin: 10px 0;
  }

  .addRule {
    border: 1px solid #409EFF;
    color: #409EFF;
    border-radius: 5px;
    text-align: center;
    line-height: 34px;
    width: 130px;
  }
}

.addProd {
  border: 1px solid #409EFF;
  color: #409EFF;
  border-radius: 5px;
  text-align: center;
  line-height: 34px;
  width: 90px;
}

.drawerContent {
  // padding: 20px;
  padding: 0 20px;
}

.tag {
  min-width: 50px;
  color: #666666;
  background-color: rgba(247, 247, 247, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(229, 230, 233, 1);
  padding: 5px;
  // line-height: 39px;
  margin: 5px;
}

/deep/ .el-drawer__header {
  color: #000 !important;
  margin-bottom: 20px !important;
}

/deep/ .el-table::before {
  background-color: transparent !important;
}
</style>
